import { Colors } from 'theme'
import React from 'react'

interface Props {
  size: number
}

const path1 = `M4 23C1.79086 23 0 24.811 0 27.0449L0 84.6854C0 86.9193 1.79086 88.7303 4 88.7303H12.7442L6.14637 101.482C5.69571 102.353 6.61466 103.296 7.48265 102.853L35.1801 88.7303H116C118.209 88.7303 120 86.9193 120 84.6854V27.0449C120 24.811 118.209 23 116 23H4Z`
const path2 = `M17.6997 85.6966L11.6906 97.3102L34.4665 85.6966H116C116.552 85.6966 117 85.2439 117 84.6854V27.0449C117 26.4865 116.552 26.0337 116 26.0337H4C3.44772 26.0337 3 26.4865 3 27.0449V84.6854C3 85.2439 3.44771 85.6966 4 85.6966H17.6997ZM7.48265 102.853C6.61466 103.296 5.69571 102.353 6.14637 101.482L12.7442 88.7303H4C1.79086 88.7303 0 86.9193 0 84.6854L0 27.0449C0 24.811 1.79086 23 4 23H116C118.209 23 120 24.811 120 27.0449V84.6854C120 86.9193 118.209 88.7303 116 88.7303H35.1801L7.48265 102.853Z`
const path3 = `M10.0113 46.8903C10.0113 44.4469 11.97 42.4662 14.3863 42.4662H105.636C108.053 42.4662 110.011 44.4469 110.011 46.8903V46.8903C110.011 49.3337 108.053 51.3145 105.636 51.3145H14.3863C11.97 51.3145 10.0113 49.3337 10.0113 46.8903V46.8903Z`
const path4 = `M10.0113 64.8398C10.0113 62.3964 11.97 60.4156 14.3863 60.4156H105.636C108.053 60.4156 110.011 62.3964 110.011 64.8398V64.8398C110.011 67.2832 108.053 69.264 105.636 69.264H14.3863C11.97 69.264 10.0113 67.2832 10.0113 64.8398V64.8398Z`

const MessageIcon = ({ size }: Props) => (
  <svg width={size} height={size} viewBox='0 0 120 120' fill='none'>
    <path fillRule='evenodd' clipRule='evenodd' d={path1} fill={Colors.White} />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d={path2}
      fill={Colors.Blue00}
    />
    <path d={path3} fill={'#A3DAEB'} />
    <path d={path4} fill={'#A3DAEB'} />
  </svg>
)

export default MessageIcon
